module.exports = "/static/assets/e6f716edc49c30d8e46444093f2c113a.svg";